import React from 'react';
import { SEO, buildBreadcrumbLd } from '../components/SEO';

const BREADCRUMB = buildBreadcrumbLd([
  { name: 'Əsas səhifə', path: '/' },
  { name: 'Haqqımızda', path: '/haqqimizda/biz-kimik' },
  { name: 'Rəhbərlik', path: '/haqqimizda/rehberlik' },
]);

const leaders = [
  {
    name: 'Elçin Həsənov',
    title: 'Direktor',
    description: 'Şirkətin strateji idarəetməsinə və ümumi fəaliyyətinə rəhbərlik edir.'
  },
  {
    name: 'Amil Əsgərov',
    title: 'Direktor Müavini',
    description: 'Gündəlik əməliyyatların təşkilini və biznes proseslərin icrasını koordinasiya edir.'
  },
  {
    name: 'Fəqan Lətifli',
    title: 'Baş Mühasib',
    description: 'Maliyyə uçotunun aparılmasına və hesabatlılığın düzgünlüyünə cavabdehdir.'
  }
];

export const LeadershipPage = () => {
  return (
    <div className="bg-white">
      <SEO
        title="Rəhbərlik | İDK BOKT"
        description="İDK BOKT-nin rəhbər heyəti — direktor, maliyyə direktoru və digər əsas vəzifə tutan şəxslər haqqında məlumat."
        path="/haqqimizda/rehberlik"
        jsonLd={BREADCRUMB}
      />
      {/* Hero */}
      <section className="bg-gradient-to-b from-blue-50 to-white pt-12 pb-8">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 font-serif-display">Rəhbərlik</h1>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            İnkişafa Dəstək Kreditləri BOKT-nin idarəetmə komandası — şirkətin strateji istiqamətini və gündəlik fəaliyyətini idarə edən rəhbər heyət.
          </p>
        </div>
      </section>

      {/* Leaders editorial list */}
      <section className="pt-4 pb-28">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
          <div className="divide-y divide-gray-200">
            {leaders.map((leader, idx) => (
              <div
                key={leader.name}
                className="group flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-10 py-9 hover:px-3 transition-all duration-300"
                data-testid={`leader-${idx + 1}`}
              >
                <div className="flex-shrink-0 w-full sm:w-72">
                  <h3 className="text-3xl sm:text-4xl font-light text-gray-900 group-hover:text-blue-700 transition-colors tracking-tight leading-tight">
                    {leader.name}
                  </h3>
                </div>
                <div className="flex-1 min-w-0">
                  <span className="block text-xs font-semibold text-blue-700 uppercase tracking-[0.18em] mb-1.5">
                    {leader.title}
                  </span>
                  <p className="text-sm text-gray-500 leading-relaxed max-w-xl">
                    {leader.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
